var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.75H4.5V7.25C4.5 7.10833 4.54792 6.98958 4.64375 6.89375C4.73958 6.79792 4.85833 6.75 5 6.75H7C7.14167 6.75 7.26042 6.79792 7.35625 6.89375C7.45208 6.98958 7.5 7.10833 7.5 7.25V9.75H9V5.25L6 3L3 5.25V9.75ZM2 9.75V5.25C2 5.09167 2.03542 4.94167 2.10625 4.8C2.17708 4.65833 2.275 4.54167 2.4 4.45L5.4 2.2C5.575 2.06667 5.775 2 6 2C6.225 2 6.425 2.06667 6.6 2.2L9.6 4.45C9.725 4.54167 9.82292 4.65833 9.89375 4.8C9.96458 4.94167 10 5.09167 10 5.25V9.75C10 10.025 9.90208 10.2604 9.70625 10.4563C9.51042 10.6521 9.275 10.75 9 10.75H7C6.85833 10.75 6.73958 10.7021 6.64375 10.6062C6.54792 10.5104 6.5 10.3917 6.5 10.25V7.75H5.5V10.25C5.5 10.3917 5.45208 10.5104 5.35625 10.6062C5.26042 10.7021 5.14167 10.75 5 10.75H3C2.725 10.75 2.48958 10.6521 2.29375 10.4563C2.09792 10.2604 2 10.025 2 9.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeS);
export default __webpack_public_path__ + "static/media/home-s.fe39621c45c2a428effe39e7ce0e140e.svg";
export { ForwardRef as ReactComponent };